import { Button, Icon, Tooltip } from 'antd';
import React, { memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { userActions } from '../../actions/user.actions';
import { PersonIcon } from '../../resource/icons';
import { RiRefreshLine } from 'react-icons/ri';
import classNames from 'classnames';
import Notifications from '../../containers/Notifications/Notifications';
import styles from './AccountMenuHeader.module.scss';
import useResetDocumentFilter from '../../hooks/useResetDocumentFilter';
import useResetHsPage from '../../hooks/useResetHsPage';
import useResetShutdownsFilter from '../../hooks/useResetShutdownsFilter';

const AccountMenuHeader = () => {
  const { pathname: path } = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  const handleResetDocumentFilter = useResetDocumentFilter();
  const handleResetShutdownsFilter = useResetShutdownsFilter();
  const resetHsPage = useResetHsPage();

  const userInfo = useSelector((store) => store.authentication.userInfo);
  const refreshFn = useSelector((store) => store.refreshStore.refreshFn);

  const logout = useCallback(async () => {
    await handleResetDocumentFilter();
    await handleResetShutdownsFilter();
    resetHsPage();
    dispatch(userActions.logout());
  }, [
    dispatch,
    handleResetDocumentFilter,
    handleResetShutdownsFilter,
    resetHsPage,
  ]);

  useEffect(() => {
    dispatch(userActions.loadUserEmail());
  }, [dispatch]);

  const onWarningClick = useCallback(() => history.push('/Profile'), [history]);

  return (
    <div className={classNames('dispex-head-menu', styles.menu)}>
      <Notifications className={styles['mr-10']} />
      <Tooltip
        title="Обновить данные"
        placement="left"
      >
        <Button
          ghost
          className={styles.refreshBtn}
          onClick={refreshFn}
        >
          <Icon component={RiRefreshLine} />
        </Button>
      </Tooltip>
      <Tooltip title="Личный кабинет">
        <Link to="/Profile">
          <div
            className={classNames(styles.person, {
              [styles.active]: path.toLowerCase() === '/profile',
            })}
          >
            <PersonIcon
              className={styles.personIcon}
              colored={path.toLowerCase() === '/profile'}
            />
            {userInfo.SurName +
              (userInfo.FirstName &&
                ' ' +
                  userInfo.FirstName.substring(0, 1) +
                  '.' +
                  (userInfo.PatrName &&
                    ' ' + userInfo.PatrName.substring(0, 1) + '.'))}
          </div>
        </Link>
      </Tooltip>
      {!userInfo.email && userInfo.isEmailLoaded && (
        <Tooltip title="Вы не сможете восстановить пароль, пока в личном кабинете не привязана почта">
          <Icon
            onClick={onWarningClick}
            type="warning"
            theme="filled"
            className={styles.warningIcon}
          />
        </Tooltip>
      )}
      <div
        onClick={logout}
        className={styles.logout}
      >
        <Icon
          type="logout"
          className={styles.logoutIcon}
        />
        Выйти
      </div>
    </div>
  );
};

export default memo(AccountMenuHeader);
